// UserManagementSection
// Renders the "Add User" form and the "Users" table.
// All state and handlers are owned by ConsoleAdmin.tsx and passed in as props.

import React, { FormEvent } from 'react';
import { ConsoleUser } from '../../../types';

interface UserManagementSectionProps {
  // Form state
  userEmail: string;
  setUserEmail: (v: string) => void;
  firstName: string;
  setFirstName: (v: string) => void;
  lastName: string;
  setLastName: (v: string) => void;
  role: 'admin' | 'business_analyst' | 'tableau_admin';
  setRole: (v: 'admin' | 'business_analyst' | 'tableau_admin') => void;
  isActive: boolean;
  setIsActive: (v: boolean) => void;

  // Submit
  handleCreateUser: (event: FormEvent) => Promise<void>;

  // Users table
  sortedUsers: ConsoleUser[];
  loadingUsers: boolean;
  handleToggleUserStatus: (target: ConsoleUser) => Promise<void>;
}

const UserManagementSection: React.FC<UserManagementSectionProps> = ({
  userEmail,
  setUserEmail,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  role,
  setRole,
  isActive,
  setIsActive,
  handleCreateUser,
  sortedUsers,
  loadingUsers,
  handleToggleUserStatus,
}) => {
  return (
    <div className="console-grid two-col">
      {/* ── Add User Form ── */}
      <div className="console-card">
        <h2>Add User</h2>
        <form className="console-form" onSubmit={handleCreateUser}>
          <label>
            Email
            <input
              value={userEmail}
              onChange={(e) => setUserEmail(e.target.value)}
              placeholder="name@consultant.jobsohio.com"
              required
            />
          </label>
          <label>
            First Name
            <input value={firstName} onChange={(e) => setFirstName(e.target.value)} />
          </label>
          <label>
            Last Name
            <input value={lastName} onChange={(e) => setLastName(e.target.value)} />
          </label>
          <label>
            Role
            <select value={role} onChange={(e) => setRole(e.target.value as 'admin' | 'business_analyst')}>
              <option value="admin">Admin</option>
              <option value="business_analyst">Business Analyst</option>
              <option value="tableau_admin">Tableau Admin</option> {/* ← ADD THIS */}
            </select>
          </label>
          <label className="checkbox-row">
            <input type="checkbox" checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />
            Active
          </label>
          <button type="submit">Save User</button>
        </form>
      </div>

      {/* ── Users Table ── */}
      <div className="console-card">
        <h2>Users</h2>
        {loadingUsers ? <p>Loading users...</p> : null}
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Email</th>
                <th>Name</th>
                <th>Role</th>
                <th>Active</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {sortedUsers.map((row) => (
                <tr key={row.user_email}>
                  <td>{row.user_email}</td>
                  <td>{`${row.user_first_name || ''} ${row.user_last_name || ''}`.trim() || '-'}</td>
                  <td>{row.user_role}</td>
                  <td>{row.is_active ? 'Yes' : 'No'}</td>
                  <td>
                    <button type="button" onClick={() => void handleToggleUserStatus(row)}>
                      {row.is_active ? 'Deactivate' : 'Activate'}
                    </button>
                  </td>
                </tr>
              ))}
              {!sortedUsers.length && !loadingUsers ? (
                <tr>
                  <td colSpan={5}>No users found.</td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default UserManagementSection;